<template>
    <div id="MainContent">
        <h1>Products</h1>
        <!-- Loading Message -->
        <p v-if="!dataLoaded">Loading...</p>
        
        <!-- Data Loaded -->
        <div v-if="dataLoaded">
            <!-- Stock Detail -->
            <StockDetails v-if="$route.params.id"></StockDetails>

            <!-- Stock List -->
            <button v-show="!$route.params.id" @click="showCreate = !showCreate">{{showCreate ?'Hide':'Show'}} Create</button><StockCreate v-show="showCreate && !$route.params.id"></StockCreate>
            
            <div v-if="!$route.params.id">
                <BaseList
                    search-placeholder="Search by product name..."
                    :filtered-count="paginatedResults.length"
                    :total-count="filteredResults.length"
                    :current-page="currentPage"
                    :items-per-page-prop="itemsPerPage"
                    @search="handleSearch"
                    @page-change="changePage"
                    @items-per-page-change="handleItemsPerPageChange"
                >
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Qty</th>
                                <th>Desc</th>
                                <th>Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="stock in paginatedResults" :key="stock.id">
                                <td><router-link :to="'/inventory/'+stock.id">{{stock.name}}</router-link></td>
                                <td>{{stock.totalStock}}</td>
                                <td>{{stock.description}}</td>
                                <td>{{stock.notes}}</td>
                            </tr>
                        </tbody>
                    </table>
                </BaseList>
            </div>
        </div> <!-- End dataLoaded -->
    </div>
</template>

<script>
    // Import Helpers
    import {CallApi, EnsureUserLoggedin} from '../Utilities.js'
    import StockDetails from '../components/StockDetails'
    import StockCreate from '../components/StockCreate'
    import BaseList from '../components/BaseList.vue'

    // Module Code
    export default {
        beforeRouteEnter: EnsureUserLoggedin,
        components: {StockDetails, StockCreate, BaseList},
        data: function () {
            return {
                showCreate: false,
                dataLoaded: false,
                inventory: [],
                filteredResults: [],
                currentPage: 1,
                itemsPerPage: 50
            }
        },
        computed: {
            paginatedResults: function() {
                const start = (this.currentPage - 1) * this.itemsPerPage;
                const end = start + this.itemsPerPage;
                return this.filteredResults.slice(start, end);
            }
        },
        methods: {
            loadInventory: function() {
                this.$router.push('/inventory/details')
            },
            fuzzyMatch: function(searchText, targetText) {
                const search = searchText.toLowerCase().trim();
                const target = targetText.toLowerCase();

                if (!search) return true;

                const searchTerms = search.split(/\s+/).map(term => {
                    const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    return `(?:^|[^a-z0-9])${escaped}`;
                });

                const pattern = searchTerms.map(term => `(?=.*${term})`).join('');
                const regex = new RegExp(pattern);

                return regex.test(target);
            },
            handleSearch: function(searchText) {
                if (!searchText) {
                    this.filteredResults = this.inventory;
                } else {
                    this.filteredResults = this.inventory.filter(item => {
                        return this.fuzzyMatch(searchText, item.name || '');
                    });
                }
                this.currentPage = 1;
            },
            changePage: function(newPage) {
                this.currentPage = newPage;
            },
            handleItemsPerPageChange: function(newValue) {
                this.itemsPerPage = newValue;
                this.currentPage = 1;
            },
            fetchData: async function() {
                this.inventory  =  (await CallApi('GET', '/inventory')).inventory
                this.filteredResults = this.inventory
                this.dataLoaded = true
            }
        },
        mounted() {
            this.fetchData();
        }
    }
</script>